import { useState } from 'react'
import Swal from 'sweetalert2'
import KampaniePlacowkiService from '@/services/KampaniePlacowkiService'

const getKampaniaName = item => item?.kampaniaName || '-'

export default function usePlacowkaKampanieActions(refreshData) {
	const [processingId, setProcessingId] = useState(null)

	const handleMarkAsUndone = async item => {
		const itemId = item?._id
		if (!itemId || !item?.doneDate) return

		const confirm = await Swal.fire({
			title: 'Oznaczyc jako niewykonane?',
			text: `Kampania: "${getKampaniaName(item)}"`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Tak, oznacz',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		setProcessingId(itemId)
		const result = await KampaniePlacowkiService.markAsUndone(itemId)
		setProcessingId(null)

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie oznaczyc kampanii jako niewykonanej',
				icon: 'error',
			})
			return
		}

		await refreshData()
	}

	const handleMarkAsDone = async item => {
		const itemId = item?._id
		if (!itemId || item?.doneDate) return

		const confirm = await Swal.fire({
			title: 'Oznaczyc jako wykonane?',
			text: `Kampania: "${getKampaniaName(item)}"`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Tak, oznacz',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		setProcessingId(itemId)
		const result = await KampaniePlacowkiService.markAsDone(itemId)
		setProcessingId(null)

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie oznaczyc kampanii jako wykonanej',
				icon: 'error',
			})
			return
		}

		await refreshData()
	}

	return {
		processingId,
		handleMarkAsDone,
		handleMarkAsUndone,
	}
}
